// import en from 'vee-validate/dist/locale/en.json'
export default (context) => {
  const timestamp = Date.now()
  return context.$axios.$get(
    `${context.$config.CDN_URL}translations/en.json?t=${timestamp}`
  )
}
